import React from 'react'

import { Card } from 'antd'
import styled from 'styled-components'

import { ChatComponentProps } from '../../types/chat/type'

import { MessageLeft, MessageRight } from './Message'
import { TextInput } from './TextFiled'

const Container = styled(Card)`
  height: 100%;
  margin-left: 10px;
`

const MessagesBody = styled.div`
  width: 90%;
  height: 90%;
  margin: 10px;
  overflow-y: scroll;
`

export const ChatComponent: React.FC<ChatComponentProps> = ({
  messages,
  message,
  setMessage,
  sendMessage,
}) => {
  return (
    <Container styles={{ body: { height: '100%' } }}>
      <MessagesBody>
        {messages.map((msg, index) =>
          msg.sender === 'あなた' ? (
            <MessageRight key={index} message={msg.text} />
          ) : (
            <MessageLeft key={index} message={msg.text} />
          )
        )}
      </MessagesBody>
      <TextInput
        sendMessage={sendMessage}
        setMessage={setMessage}
        message={message}
      />
    </Container>
  )
}
